<template>
  <header
    class="flex justify-between items-center dark:bg-nucleus-darkBlue"
    :class="{
      'bg-black': checkAccessPage(currentRouteName),
    }"
  >
    <div class="p-25px">
      <img
        :src="require(`@/assets/` + logo)"
        alt="Sony Logo Black"
        class="w-auto h-25px"
      />
    </div>
    <!-- <div>
      <DarkToggle></DarkToggle>
    </div> -->

    <div class="flex items-center">
      <UserMenu v-if="showUserMenu" :current-page="currentRouteName"></UserMenu>
      <RegionMenu
        v-if="
          currentRouteName === 'EulaPrivacyPolicy' && currentRouteQuery.static
        "
      />
      <LanguageMenu />
    </div>

    <!-- <router-link to="/settings" class="block"
      ><span
        class="
          block
          align-middle
          text-3xl text-nucleus-grey
          dark:text-white
          icon-settings
        "
        ></span
      ></router-link
    > -->
  </header>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import UserMenu from "@/components/global/UserMenu.vue"; // @ is an alias to /src
import { isAccessPage } from "@/utils/isAccessPage";
import LanguageMenu from "@/components/global/LanguageMenu.vue"; // @ is an alias to /src
import RegionMenu from "@/components/global/RegionMenu.vue"; // @ is an alias to /src

@Options({
  components: {
    UserMenu,
    LanguageMenu,
    RegionMenu,
  },
  computed: {
    showUserMenu() {
      let user = this.$store.getters.getUserObject;
      return user && user.attributes;
    },
    logo() {
      if (this.checkAccessPage(this.currentRouteName)) {
        return "logo_white.svg";
      } else {
        return "logo_black.svg";
      }
    },
    currentRouteName() {
      return this.$route.name;
    },
    currentRouteQuery() {
      return this.$route.query;
    },
  },
  methods: {
    checkAccessPage(route: string) {
      return isAccessPage(route);
    },
  },
})
export default class Home extends Vue {}
</script>
